import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCurrentVariantCohort } from 'root-redux/selects/common'

import { ChildCohort, Cohort, DYNAMIC_DISCOUNT_COHORTS } from 'root-constants'

import { useCohortToUse } from './useCohortToUse'

export const useActiveCohortIdentifier = () => {
  const cohortToUse = useCohortToUse()
  const cohort = useSelector(selectCurrentVariantCohort) as string

  return useMemo(
    () => ({
      isLuvlyIntroFastCohort: cohortToUse === Cohort.LUVLY_INTRO_FAST,
      isCosmeticCohort: cohortToUse === Cohort.LUVLY_COSMETIC_SCANNER,
      isChatCohort: cohortToUse === Cohort.LUVLY_CHAT,
      isUpgradeBundleCohort:
        cohortToUse === Cohort.LUVLY_CHAT_UPGRADE_BUNDLE_PDF,
      isDynamicDiscountCohort: DYNAMIC_DISCOUNT_COHORTS.includes(cohortToUse),
      isLuvlyIntroSaleCohort: cohortToUse === Cohort.LUVLY_INTRO_SALE,
      isRefundCohort:
        cohortToUse === Cohort.LUVLY_REF ||
        cohortToUse === Cohort.LUVLY_REF03 ||
        cohortToUse === Cohort.LUVLY_REF4 ||
        cohortToUse === Cohort.LUVLY_PRINTABLE ||
        cohortToUse === Cohort.LUVLY_AREF ||
        cohortToUse === Cohort.LUVLY_REF4_TT,
      isLuvlyCancelIntro1Cohort: cohortToUse === Cohort.LUVLY_CANCEL_INTRO_1,
      isLuvlyChinCohort: cohortToUse === Cohort.LUVLY_CHIN,
      isLuvlyEmailSaleCohort: cohortToUse === Cohort.LUVLY_EMAIL_SALE,
      isLuvlyInfluencersCohort: cohortToUse === Cohort.LUVLY_INFLUENCERS,
      isLuvlyGiftCardCohort: cohortToUse === Cohort.LUVLY_GIFT,
      isCoralThemeCohort: cohortToUse === Cohort.LUVLY_CHIN,
      isLuvlyWellhubCohort: cohortToUse === Cohort.LUVLY_WELLHUB,
      isLuvlyEmailCoaching: cohortToUse === Cohort.LUVLY_EMAIL_COACHING,
      isLuvlyPrintableCohort: cohortToUse === Cohort.LUVLY_PRINTABLE,
      isRefund4Cohort: cohortToUse === Cohort.LUVLY_REF4,
      isRefOrRef4Cohort:
        cohortToUse === Cohort.LUVLY_REF ||
        cohortToUse === Cohort.LUVLY_REF03 ||
        cohortToUse === Cohort.LUVLY_REF4,
      isArefCohort: cohortToUse === Cohort.LUVLY_AREF,
      isLuvlyRef4TTCohort: cohortToUse === Cohort.LUVLY_REF4_TT,
      isLuvlyGrowthCohort: cohort === ChildCohort.LUVLY_REF_GROWTH,
    }),
    [cohortToUse, cohort],
  )
}
